export const MY_TOTAL_BUDGET = "MY_TOTAL_BUDGET";
export const MY_TOTAL_BUDGET_IS_EDITING = "MY_TOTAL_BUDGET_IS_EDITING";
export const SET_REMAINING = "SET_REMAINING";
export const SET_TOTAL_EXPENSES_COST = "SET_TOTAL_EXPENSES_COST";
export const SET_EXPENSE_NAME = "SET_EXPENSE_NAME";
export const SET_EXPENSE_COST = "SET_EXPENSE_COST";
export const SET_EXPENSE_DATE = "SET_EXPENSE_DATE";
export const ADD_EXPENSE_IN_EXPENSE_LIST = "ADD_EXPENSE_IN_EXPENSE_LIST";
export const CLEAR_FIELDS = "CLEAR_FIELDS";
